/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {GestationalProfileData} from "@doctor-panel-modules/doctor-shared/gestational-profile-form/gestational-profile-form.component";
import {ContestoApp} from "@trec/api";
import {ClinicalData} from "@trec/api/clinical-data";
import {RangeDates} from "@trec/api/common";
import {TrecApiError} from "@trec/api/errors";
import {Key2} from "@trec/api/registry";
import {ErrorAction, StoreAction} from "@trec/components/store";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AppPrescriptionActions {
  // App features /////////////////////////////////////////////////////////////////////////////////

  export class FetchAppFeaturesTranslations extends StoreAction {
    static readonly type = `[App Prescription] Fetch app features translations`;
  }

  // Prescription /////////////////////////////////////////////////////////////////////////////////

  export class PrescribeApp extends StoreAction {
    static readonly type = `[App Prescription] Prescribe app`;

    constructor(public payload: {dates: RangeDates, contestoApp: ContestoApp}) {
      super();
    }
  }

  export class PrescribeAppError extends ErrorAction {
    static readonly type = `[App Prescription] Prescribe app error`;
    readonly error: true = true;

    readonly errorMsgs = {
      profile_sync_err: `Si è verificato un errore lato server durante il salvataggio dei dati. Se il problema persiste, contattare l'assistenza`,
    };

    constructor(public payload: TrecApiError) {
      super();
    }
  }

  export class InsertAppPrescrGestationalProfileData extends StoreAction {
    static readonly type = `[App Prescription] Insert gestational data`;

    constructor(public payload: {gestationalData: GestationalProfileData}) {
      super();
    }
  }

  export class InsertClinicalDataList extends StoreAction {
    static readonly type = `[App Prescription] Insert clinical data list`;

    constructor(public payload: {list: ClinicalData<any>[]}) {
      super();
    }
  }

  export class AddUeKeys extends StoreAction {
    static readonly type = `[App Prescription] Add UserEntry leys`;

    constructor(public payload: {keys: Key2[]}) {
      super();
    }
  }

  // Clear status ///////////////////////////////////////////////////////////////////////////////////

  export class ClearStatus extends StoreAction {
    static readonly type = `[App Prescription] Clear status`;
  }
}
